import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FullTable, AddButton, CustomDelete, SelectedFilters } from 'components';
import { FindSuccessItem, PermissionList, RolePermission, useModal } from 'utils';
import { formActions, httpRequestsOnSuccessActions } from 'store';
import {
    ACTION_TYPE,
    formBody,
    formBuilderStatusEnums,
    formHead,
    formModelsList,
    formNotYet,
    formStatusFilterList,
} from './constants';
import { EditForm, CreateFormModal } from './fragments';
import axios from 'axios';

const EDIT_ACTION_TYPE = 'EDIT_FORM';
const DELETE_ACTION_TYPE = 'DELETE_FORM';
const CHANGE_STATUS_ACTION_TYPE = 'CHANGE_FORM_STATUS';
export const Forms = () => {
    const forms = useSelector((state) => state.forms.forms);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open, close } = useModal();
    const success = FindSuccessItem(EDIT_ACTION_TYPE);
    const successDelete = FindSuccessItem(DELETE_ACTION_TYPE);
    const successStatus = FindSuccessItem(CHANGE_STATUS_ACTION_TYPE);
    const [selectedId, setSelectedId] = useState();

    /**
     * Both of this grid's filters, each a column-header dropdown.
     *
     * The Template Name column search sends `searchKey: TITLE` + `searchValue` (escaped `^title`
     * prefix match, see `formBuilder.service.ts`); it lives in the header input, not a chip.
     */
    const filtersList = [
        { name: 'Template Type', key: 'model', options: formModelsList },
        { name: 'Status', key: 'status', options: formStatusFilterList },
    ];

    const getFsSources = (loading) => {
        const filteredInfo = {
            ...info,
            sortType: 'createdAt',
            sortOrder: 'DESC',
        };
        filteredInfo.skip = info?.skip ? info?.skip : 0;
        filteredInfo.limit = 50;
        delete filteredInfo.page;
        dispatch(formActions.getForms(filteredInfo, loading));
    };

    useEffect(() => {
        getFsSources();
    }, [info]);

    useEffect(() => {
        if (success) {
            close();
            getFsSources('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_ACTION_TYPE));
        }
        if (successDelete) {
            close();
            getFsSources('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
        }
        if (successStatus) {
            getFsSources('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CHANGE_STATUS_ACTION_TYPE));
        }
    }, [success, successDelete, successStatus]);

    const handleAction = (item, name) => {
        if (name === 'duplicate') {
            setSelectedId(item?.id);
            axios.get(`/form-builder/${item?.id}`, { auth: true }).then((res) => {
                const formData = res?.data;
                if (formData) {
                    const duplicateData = { ...formData };
                    delete duplicateData._id;
                    delete duplicateData.id;
                    delete duplicateData.status;
                    delete duplicateData.createdAt;
                    delete duplicateData.updatedAt;
                    setSelectedId(null);
                    // Create is a modal now (the old /create-form builder-create route
                    // is gone), so duplicate opens the same modal pre-filled with the
                    // copied content instead of navigating to a dead route.
                    open(<CreateFormModal duplicateData={duplicateData} />);
                }
            });
        }
        if (name === 'delete') {
            open(
                <CustomDelete
                    info="Delete Template ?"
                    text="Are you sure you want to delete this template. This action cannot be undone."
                    handleDel={() => dispatch(formActions.deleteForms(item?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    // afterSuccess={() => getFsSources('noLoad')}
                />,
            );
        }
        if (name === 'edit') {
            open(<EditForm info={item} />);
        }
        if (name === 'toggleStatus') {
            const newStatus =
                item?.status === formBuilderStatusEnums.UNPUBLISHED
                    ? formBuilderStatusEnums.PUBLISHED
                    : formBuilderStatusEnums.UNPUBLISHED;
            dispatch(formActions.changeFormStatus(item?.id, newStatus));
        }
        // if (name === 'download') {
        //     setSelectedId(item?.id);
        //     axios({
        //         url: `/custom-forms/download/${item?.id}`,
        //         method: 'GET',
        //         responseType: 'blob',
        //         headers: { 'access-token': `${token()}` },
        //     })
        //         .then((response) => {
        //             setSelectedId('');
        //             const url = window.URL.createObjectURL(new Blob([response?.data]));
        //             const link = document.createElement('a');
        //             link.href = url;
        //             link.setAttribute('download', `${item?.title || 'form'}.pdf`);
        //             document.body.appendChild(link);
        //             link.click();
        //         })
        //         .catch(() => {
        //             setSelectedId('');
        //         });
        // }
    };

    return (
        <>
            {RolePermission([PermissionList.MANAGE_CUSTOM_FORM?.code]) && (
                <div className="flex-end">
                    <AddButton text={'Create New Template'} handleClick={() => open(<CreateFormModal />)} />
                </div>
            )}

            <SelectedFilters filtersList={filtersList} doNotCrop />

            <FullTable
                head={formHead}
                body={formBody(selectedId)}
                loadingType={ACTION_TYPE}
                list={forms?.data}
                listCount={forms?.count}
                handleClick={(id) => navigate(`/template/${id}`)}
                handleClickButton={handleAction}
                notYet={formNotYet}
                margin={'12px 0 0 0'}
            />
        </>
    );
};
